/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'warning': {
    width: 16,
    height: 16,
    viewBox: '0 0 1024 1024',
    data: '<path pid="0" _fill="currentColor" d="M555.644 106.37a87.982 87.982 0 0132.738 32.74l376.282 658.493c24.108 42.19 9.45 95.933-32.738 120.041a87.982 87.982 0 01-43.651 11.592H135.71c-48.59 0-87.982-39.39-87.982-87.981a87.982 87.982 0 0111.592-43.652L435.603 139.11c24.108-42.189 77.852-56.846 120.04-32.738zm-43.652 76.39L135.71 841.255h752.565zm-2.36 472.888c31.423 0 54.99 23.227 54.99 54.9 0 31.674-23.567 54.9-54.99 54.9-32.135 0-54.988-23.226-54.988-55.604 0-30.97 23.567-54.196 54.989-54.196zm43.992-340.93v263.946h-87.982V314.718z" stroke-width="1.32"/>'
  }
})
